export const ACTIONS_PREFIX = 'Sitemap';
